import { useMemo } from 'react';
import UserInitialsComponent from './UserInitials.component';

export type UserInitialsProps = {
  firstName: string;
  lastName?: string;
  pictureUrl?: string;
  size?: number;
  fontSize?: number;
  className?: string;
};

const UserInitials = ({ firstName, lastName, ...props }: UserInitialsProps): JSX.Element => {
  const candidateInitials = useMemo(() => {
    const firstLetter = firstName ? firstName[0] || '' : '';
    const secondLetter = lastName ? lastName[0] || '' : '';

    return `${firstLetter}${secondLetter}`;
  }, [firstName, lastName]);

  const name = `${firstName ?? ''}${lastName ? ` ${lastName}` : ''}`;

  return <UserInitialsComponent initials={candidateInitials} title={name} {...props} />;
};

export default UserInitials;
